import { useSelector, useDispatch } from "react-redux";

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

import classes from "./content.module.scss";

import { isMobile } from "@/services/Utils";

import { HANDLE_SIDEBAR } from "@/redux/types/main.types";

const Content = ({ props }) => {
	const dispatch = useDispatch();

	const { openSidebar } = useSelector((state) => state.main);

	const token = localStorage.getItem("token");

	const changeOpenSidebar = (open) => {
		dispatch({
			type: HANDLE_SIDEBAR,
			payload: {
				openSidebar: open,
			},
		});
	};

	return (
		<div className={`${classes.layoutContainer} ${isMobile() ? classes.mobile : ""}`}>
			{token && <Header changeOpenSidebar={changeOpenSidebar} />}

			<div className={classes.mainContent}>
				{token && (
					<div className={classes.sidebarWrapper}>
						<Sidebar />
					</div>
				)}

				<div className={`${classes.contentWrapper} ${openSidebar ? classes.expanded : classes.collapsed}`}>
					<div className={`${isMobile() ? classes.mobileContent : classes.normalContent}`}>{props.children}</div>
				</div>
			</div>
		</div>
	);
};

export default Content;
